import { formatTimeISO } from '@repo/common';
import { SDSText } from '@repo/sds/SDSText';
import { getStartOfPeriod, getWeekDays, getWeekdayLettersLabel } from '@repo/ui/utils/time/week-time';

import './MonthlyCalendarWeekdayLabels.scss';

export function MonthlyCalendarWeekdayLabels() {
  const startOfWeek = getStartOfPeriod(new Date(), 'week');
  const weekdays = getWeekDays(startOfWeek);

  return (
    <div className="MonthlyCalendarWeekdayLabels">
      {weekdays.map(day => (
        <SDSText
          key={formatTimeISO(day)}
          text={getWeekdayLettersLabel(day)}
          type="button-medium"
          color="text-secondary"
          className="MonthlyCalendarWeekdayLabels__label"
        />
      ))}
    </div>
  );
}
